import useSlideoutDateScope from './useSlideoutDateScope';
import useSlideoutRollingDateScope from './useSlideoutRollingDateScope';

const FALLBACK_INTERVAL: PerformanceBoardTypes.SlideOut.SlideOutDateRange = {
  mode: 'Current Interval',
  isToDate: false,
};

/**
 * Resolves a slide-out section's {@link PerformanceBoardTypes.SlideOut.SlideOutDateFilter}
 * into the query date scope. Both underlying hooks are always called (rules of
 * hooks); the active mode picks which result is used.
 */
const useSlideoutDateFilterScope = (
  dateFilter: PerformanceBoardTypes.SlideOut.SlideOutDateFilter,
): DateRangeInput | undefined => {
  const rolling = dateFilter.mode === 'Rolling' ? dateFilter : undefined;
  const periodsInterval =
    dateFilter.mode === 'Periods' ? dateFilter.interval : FALLBACK_INTERVAL;

  const rollingDateScope = useSlideoutRollingDateScope(rolling);
  const periodsDateScope = useSlideoutDateScope(
    periodsInterval,
    dateFilter.dateField,
  );

  return rolling ? rollingDateScope : periodsDateScope;
};

export default useSlideoutDateFilterScope;
